import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { DialogTitle, DialogContent } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 10,
  },
  timetableEntry: {
    marginTop: 10,
    marginBottom: 20,
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class TimetablePupilNoteContentDialog extends React.Component {
  render() {
    const {
      t,
      classes,
      isDialogOpen,
      onDialogClose,
      timetableEntries,
    } = this.props;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isDialogOpen}
        fullWidth
        maxWidth="md"
        onClose={onDialogClose}
        TransitionComponent={Transition}
        disableBackdropClick={true}
        className="timetable-pupil-note-content-dialog"
      >
        <DialogTitle id="timetable-pupil-note-content-dialog-title" onClose={onDialogClose}>
          {appType === 'student' ? t('Your Notes') : t('Pupil Notes')}
          <IconButton
            aria-label="Close"
            onClick={onDialogClose}
            className={`timetable-pupil-note-content-dialog-close-button ${classes.closeIcon}`}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {timetableEntries.map(timetableEntry => (
            <div className={classes.timetableEntry} key={timetableEntry.key}>
              <b>{timetableEntry.lesson_name}</b>
              {timetableEntry.subject_name ? ' (' + timetableEntry.subject_name + ')' : ''}
              <div dangerouslySetInnerHTML={{
                __html: timetableEntry.pupil_note,
              }}></div>
            </div>
          ))}
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withTranslation()(TimetablePupilNoteContentDialog));

